export enum TailwindBreakpoints {
  MOBILE = '400px',
  SM = '640px',
  MD = '768px',
  LG = '1024px',
  XL = '1280px',
  XXL = '1536px',
}

// Exact complement of Tailwind `md:` (min-width: 768px), so 768px renders desktop.
export const MOBILE_VIEWPORT_MAX_WIDTH = '767.98px';

export const MOBILE_VIEWPORT_QUERY = `(max-width: ${MOBILE_VIEWPORT_MAX_WIDTH})`;

// Widths of the page content box (PageScaffold), not the screen. Class strings need literals: mirror these in `@[480px]/page:` etc.
export enum PageContainerBreakpoints {
  COMPACT = 480,
  MEDIUM = 768,
  WIDE = 1024,
}
